<template>
  <b-container fluid>
    <b-row align-h="center">
      <b-col cols="12" sm="8" lg="5">

        <div class="div-section-header">
          <b-row>
            <b-col cols="12">
              <div>
                <span class="txt-section-title">Recover Viva Account</span>
              </div>
            </b-col>
          </b-row>
        </div>

        <transition name="fade" mode="out-in">
          <b-alert v-if="error" key="error-box" show variant="danger" class="mt-2">
            {{errorMsg}}
          </b-alert>
          <b-alert v-if="success" key="success-box" show variant="info" class="mt-2">
            Password updated.  Click Login button to access your account.
            <div class="mt-2 text-center">
              <b-button to="/login">Login</b-button>
            </div>
          </b-alert>
        </transition>

        <b-overlay :show="busy">
            <b-form @submit.stop.prevent="resetPassword" v-show="!success">

                <b-row>
                    <b-col cols="12">
                    <div class="px-2">
                        <!-- New password -->
                        <b-form-group
                        label="New Password"
                        label-for="password"
                        label-size="sm"
                        class="mb-2"
                        label-class="mb-0 pt-2 font-weight-bold"
                        >
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                            <b-icon icon="lock"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input
                            id="password"
                            v-model="$v.passwords.password.$model"
                            type="password"
                            placeholder="New password"
                            :state="validateState('password')"
                            aria-describedby="support-password-feedback"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="!$v.passwords.password.required">Password is required.</b-form-invalid-feedback>
                            <b-form-invalid-feedback v-if="!$v.passwords.password.minLength">Password must be 6 characters or longer.</b-form-invalid-feedback>
                            <b-form-invalid-feedback v-if="!$v.passwords.password.regexPwd">Invalid character(s) detected.</b-form-invalid-feedback>
                            <!-- <b-form-invalid-feedback id="support-password-feedback">Password is required.</b-form-invalid-feedback> -->
                        </b-input-group>
                        </b-form-group>

                        <!-- New password retype -->
                        <b-form-group
                        label="New Password (retype)"
                        label-for="password2"
                        label-size="sm"
                        class="mb-2"
                        label-class="mb-0 pt-2 font-weight-bold"
                        >
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                            <b-icon icon="lock"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input
                            id="password2"
                            v-model="$v.passwords.password2.$model"
                            type="password"
                            placeholder="New password (retype)"
                            :state="validateState('password2')"
                            aria-describedby="support-password2-feedback"
                            ></b-form-input>
                            <b-form-invalid-feedback id="support-password2-feedback">Passwords must match.</b-form-invalid-feedback>
                        </b-input-group>
                        </b-form-group>

                        <transition name="fade" mode="out-in">
                        <div>
                            <b-alert
                            v-model="error"
                            key="error-box"
                            show
                            variant="danger"
                            dismissible
                            class="mt-2"
                            >{{errorMsg}}</b-alert>
                            <b-alert
                            v-model="success"
                            key="success-box"
                            show
                            variant="success"
                            dismissible
                            class="mt-2"
                            >Account password updated.</b-alert>
                        </div>
                        </transition>

                        <div class="text-center mt-2 mb-2">
                        <b-button type="submit" variant="info">Update Password</b-button>
                        </div>
                    </div>
                    </b-col>
                </b-row>
            </b-form>
        </b-overlay>

        <div class="text-right mt-1">
          <router-link to="/login">Return to Login</router-link>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
/* eslint-disable */
'use strict'

// URL paramas
// https://www.thepolyglotdeveloper.com/2017/11/pass-data-between-routes-vuejs-web-application/
// import router from "../router";

import service from "../service/service";
import utils from "../utils/utils";

import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength,
  between,
  sameAs,
  helpers
} from "vuelidate/lib/validators";

// Password regex: Allow alphanumeric and some special characters
const regexPwd = helpers.regex('regexPwd', /^[a-zA-Z0-9.!@#$%&*~:;?+=^_-]*$/)

// using props for url parameters
// https://www.youtube.com/watch?v=ESg0k2zdME4

export default {
  name: "ResetPassword",
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: "System error - contact tech support.",
      loading: false,
      busy: false,
      success: false,
      passwords: {
        password: null,
        password2: null
      },
      msg: "Use the form below to reset account password.",
      resetToken: null
    }
  },
  props: {
    // route set to use props mapped to url parameters
    t: {
      type: String,
      default: ""
    }
  },
  mixins: [validationMixin],
  validations: {
    passwords: {
      password: {
        required,
        minLength: minLength(6),
        regexPwd
      },
      password2: {
        sameAsPassword: sameAs("password")
      }
    }
  },
  computed: {
    isLoggedIn() {
        return this.$root.hasToken()
    }
  },
  methods: {
    validateState(name) {
      // console.log(`name: ${name}`)
      const { $dirty, $error } = this.$v.passwords[name];
      return $dirty ? !$error : null;
    },
    resetPassword(e) {
        this.$v.passwords.$touch();
      if (this.$v.passwords.$anyError) {
        console.log(`Validation ERROR!!`);
        return;
      }
      this.error = false;
      this.success = false;
      this.busy = true;

      service
        .resetPassword(this.passwords.password, this.resetToken)
        .then(res => {
          if (this.debug) console.log(res.data)
          if (res.status) {
            this.success = true
          } else {
            this.success = false
            this.errorMsg = data.errorMsg || "Service error."
            this.error = true;
          }
        })
        .finally(() => {
          this.busy = false
        })
        .catch(e => {
          console.log(e);
          this.error = true;
        })    }
  },
  created() {
    if (this.isLoggedIn) {  // must be logged out
      this.$router.push("/logout").then( () => { location.reload() })
    }
    this.resetToken = this.t
    if (this.debug) console.log(`resetToken: ${this.resetToken}`)
  },
  mounted() {},
  beforeDestroy() {
    this.success = false
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue